// Import modules
import History from './History';
import HistoryWithSlug from './HistoryWithSlug';
// Export modules
export { HistoryWithSlug };
export default History;
